(function (root, factory) {
  'use strict';
  var api = factory();
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
  if (typeof window !== 'undefined') {
    window.CompatFinder = api;
    if (typeof document !== 'undefined') api._boot();
  }
})(this, function () {
  'use strict';

  /* ===================== pure core (unit-tested) ===================== */
  function norm(s) {
    return String(s == null ? '' : s)
      .normalize('NFD').replace(/[̀-ͯ]/g, '')
      .toLowerCase().trim().replace(/\s+/g, ' ');
  }
  function tokenize(q) {
    return norm(q).split(' ').filter(Boolean);
  }
  function hay(p) {
    if (p._hay == null) {
      p._title = norm(p.title);
      p._hay = norm([p.title, p.type, p.vendor, (p.cc || []).join(' ')].join(' '));
    }
    return p;
  }
  function searchProducts(list, q, limit) {
    var terms = tokenize(q);
    if (!terms.length) return [];
    var out = list.filter(function (p) {
      hay(p);
      return terms.every(function (t) { return p._hay.indexOf(t) !== -1; });
    }).sort(function (x, y) {
      var sx = terms.filter(function (t) { return x._title.indexOf(t) !== -1; }).length;
      var sy = terms.filter(function (t) { return y._title.indexOf(t) !== -1; }).length;
      if (sy !== sx) return sy - sx;
      return x._title.localeCompare(y._title);
    });
    return limit ? out.slice(0, limit) : out;
  }
  function filterResults(list, q) {
    var terms = tokenize(q);
    if (!terms.length) return list.slice();
    return list.filter(function (p) {
      hay(p);
      return terms.every(function (t) { return p._hay.indexOf(t) !== -1; });
    });
  }

  /* ===================== helpers ===================== */
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }
  function highlight(text, terms) {
    var out = esc(text);
    terms.forEach(function (t) {
      out = out.replace(new RegExp('(' + t.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + ')', 'ig'), '<mark>$1</mark>');
    });
    return out;
  }
  function thumb(url, cls) {
    return url
      ? '<img class="' + cls + '" src="' + esc(url) + '" alt="" loading="lazy">'
      : '<span class="' + cls + ' cf-ph"></span>';
  }
  var VIEW_ICON = '<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round"><path d="M7 17 17 7"/><path d="M8 7h9v9"/></svg>';

  var S = {
    hosts: [], collections: {}, byHandle: {},
    cfg: {}, root: null, view: null,
    selected: null, entries: [], activeChip: 'All', hi: -1
  };

  /* ===================== boot ===================== */
  function boot() {
    var root = document.querySelector('[data-compat-app]');
    if (!root) return;
    var view = root.querySelector('[data-compat-view]');
    if (!view) return;
    S.root = root; S.view = view;
    S.cfg = {
      src: root.getAttribute('data-src') || '',
      heading: root.getAttribute('data-heading') || 'Find compatible parts',
      sub: root.getAttribute('data-sub') || '',
      pickerPh: root.getAttribute('data-picker-placeholder') || 'Search a product…',
      filterPh: root.getAttribute('data-filter-placeholder') || 'Filter compatible items…',
      emptyTitle: root.getAttribute('data-empty-title') || 'No product selected yet',
      emptyBody: root.getAttribute('data-empty-body') || '',
      compatHeading: root.getAttribute('data-compat-heading') || 'Compatible parts & add-ons'
    };
    renderShell();
    if (!S.cfg.src) { return; }
    fetch(S.cfg.src, { headers: { 'Accept': 'application/json' } })
      .then(function (r) { if (!r.ok) throw new Error('no data'); return r.json(); })
      .then(function (data) {
        S.hosts = (data.hosts || []);
        S.collections = (data.collections || {});
        S.hosts.forEach(function (h) { S.byHandle[h.handle] = h; });
        wirePicker();
        renderEmptyState();
        routeFromHash();
        window.addEventListener('hashchange', routeFromHash);
      })
      .catch(function () { renderEmptyState(true); });
  }

  function renderShell() {
    var c = S.cfg;
    S.view.innerHTML =
      '<section class="cf-hero">' +
        '<h1>' + esc(c.heading) + '</h1>' +
        (c.sub ? '<p class="cf-sub">' + esc(c.sub) + '</p>' : '') +
        '<div class="cf-pick">' +
          '<div class="cf-pick-field">' +
            '<svg class="cf-ic" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"><circle cx="11" cy="11" r="7"/><path d="m20 20-3.2-3.2"/></svg>' +
            '<input type="search" data-picker placeholder="' + esc(c.pickerPh) + '" aria-label="' + esc(c.pickerPh) + '" autocomplete="off" spellcheck="false">' +
            '<span class="cf-kbd">↑↓ ↵</span>' +
          '</div>' +
          '<div class="cf-results" data-picker-results hidden role="listbox"></div>' +
        '</div>' +
      '</section>' +
      '<section data-results-wrap></section>';
  }

  /* ===================== picker ===================== */
  function wirePicker() {
    var input = S.view.querySelector('[data-picker]');
    var box = S.view.querySelector('[data-picker-results]');
    function hide() { box.hidden = true; box.innerHTML = ''; S.hi = -1; }
    function run() {
      var q = input.value;
      var terms = tokenize(q);
      S.hi = -1;
      if (!terms.length) { hide(); return; }
      var matches = searchProducts(S.hosts, q, 8);
      if (!matches.length) {
        box.innerHTML = '<div class="cf-res-empty">No products match “' + esc(q.trim()) + '”.</div>';
      } else {
        box.innerHTML = matches.map(function (h, i) {
          var n = (h.cc || []).reduce(function (a, ch) { return a + ((S.collections[ch] || {}).products || []).length; }, 0);
          return '<div class="cf-res-item" role="option" data-pick="' + esc(h.handle) + '" data-i="' + i + '">' +
            thumb(h.image, 'cf-res-thumb') +
            '<span class="cf-res-main"><span class="cf-res-name">' + highlight(h.title, terms) + '</span>' +
            '<span class="cf-res-meta">' + n + ' compatible · ' + esc(h.price) + '</span></span>' +
            (h.type ? '<span class="cf-res-cat">' + esc(h.type) + '</span>' : '') +
          '</div>';
        }).join('');
      }
      box.hidden = false;
    }
    function move(d) {
      var items = [].slice.call(box.querySelectorAll('.cf-res-item'));
      if (!items.length) return;
      S.hi = (S.hi + d + items.length) % items.length;
      items.forEach(function (el, i) { el.setAttribute('aria-selected', i === S.hi); });
      items[S.hi].scrollIntoView({ block: 'nearest' });
    }
    input.addEventListener('input', run);
    input.addEventListener('focus', function () { if (input.value.trim()) run(); });
    input.addEventListener('keydown', function (e) {
      if (box.hidden) return;
      if (e.key === 'ArrowDown') { e.preventDefault(); move(1); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); move(-1); }
      else if (e.key === 'Enter') {
        e.preventDefault();
        var items = [].slice.call(box.querySelectorAll('.cf-res-item'));
        var pick = S.hi >= 0 ? items[S.hi] : items[0];
        if (pick) { location.hash = '#/p/' + pick.getAttribute('data-pick'); hide(); input.value = ''; }
      } else if (e.key === 'Escape') { hide(); input.blur(); }
    });
    box.addEventListener('click', function (e) {
      var it = e.target.closest('[data-pick]');
      if (it) { location.hash = '#/p/' + it.getAttribute('data-pick'); hide(); input.value = ''; }
    });
    document.addEventListener('click', function (e) {
      if (!e.target.closest('.cf-pick')) hide();
    });
  }

  function routeFromHash() {
    var h = location.hash || '';
    if (h.indexOf('#/p/') === 0) {
      var host = S.byHandle[h.slice(4)];
      if (host) { selectHost(host); return; }
    }
    S.selected = null;
    renderEmptyState();
  }

  function renderEmptyState(failed) {
    var w = S.view.querySelector('[data-results-wrap]');
    if (!w) return;
    var chips = S.hosts.slice(0, 4).map(function (h) {
      return '<button class="cf-es-chip" data-pick="' + esc(h.handle) + '">' + esc(h.title) + '</button>';
    }).join('');
    w.innerHTML =
      '<div class="cf-empty">' +
        '<svg class="cf-es-ico" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4"><path d="M3 7l9-4 9 4-9 4-9-4Z"/><path d="M3 12l9 4 9-4"/><path d="M3 17l9 4 9-4"/></svg>' +
        '<b>' + esc(failed ? 'Compatibility data isn’t ready yet' : S.cfg.emptyTitle) + '</b>' +
        '<span>' + esc(failed ? 'Run the rebuild job to publish the dataset.' : S.cfg.emptyBody) + '</span>' +
        (chips ? '<div class="cf-es-chips">' + chips + '</div>' : '') +
      '</div>';
    var box = w.querySelector('.cf-es-chips');
    if (box) box.addEventListener('click', function (e) {
      var b = e.target.closest('[data-pick]'); if (b) location.hash = '#/p/' + b.getAttribute('data-pick');
    });
  }

  /* ===================== results ===================== */
  function compatibleOf(host) {
    var seen = {};
    var out = [];
    (host.cc || []).forEach(function (ch) {
      var col = S.collections[ch];
      if (!col) return;
      (col.products || []).forEach(function (p) {
        if (p.handle === host.handle) return;
        var e = seen[p.handle];
        if (e) { if (e.chips.indexOf(ch) === -1) e.chips.push(ch); return; }
        e = { part: p, chips: [ch] };
        seen[p.handle] = e;
        out.push(e);
      });
    });
    out.sort(function (a, b) { return a.part.title.localeCompare(b.part.title); });
    return out;
  }

  function selectHost(host) {
    S.selected = host;
    S.entries = compatibleOf(host);
    S.activeChip = 'All';
    renderResults();
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  function chipTitle(ch) { return (S.collections[ch] || {}).title || ch; }

  function badges(chips) {
    return chips.map(function (ch) { return '<span class="cf-badge">' + esc(chipTitle(ch)) + '</span>'; }).join('');
  }

  function card(entry) {
    var p = entry.part;
    var action = !p.single_variant
      ? '<a class="cf-btn cf-btn--opt" href="' + esc(p.url) + '">Choose options</a>'
      : (p.available
          ? '<button type="button" class="cf-btn" data-add="' + p.variant_id + '">Add to cart</button>'
          : '<span class="cf-btn cf-btn--sold" aria-disabled="true">Sold out</span>');
    return '<article class="cf-item">' +
      '<a class="cf-item-media" href="' + esc(p.url) + '">' + thumb(p.image, 'cf-item-img') + '</a>' +
      '<div class="cf-item-body">' +
        '<div class="cf-badges">' + badges(entry.chips) + '</div>' +
        '<a class="cf-item-name" href="' + esc(p.url) + '">' + esc(p.title) + '</a>' +
        '<div class="cf-item-foot">' +
          '<span class="cf-price">' + esc(p.price) + '</span>' +
          '<span class="cf-actions">' + action +
            '<a class="cf-view" href="' + esc(p.url) + '">' + VIEW_ICON + ' View</a>' +
          '</span>' +
        '</div>' +
      '</div></article>';
  }

  function renderResults() {
    var wrap = S.view.querySelector('[data-results-wrap]');
    var h = S.selected;
    var card0 =
      '<article class="cf-pcard">' +
        '<a class="cf-pc-media" href="' + esc(h.url) + '">' + thumb(h.image, 'cf-pc-img') + '</a>' +
        '<div class="cf-pc-body">' +
          (h.type ? '<div class="cf-pc-eyebrow">' + esc(h.type) + '</div>' : '') +
          '<div class="cf-pc-name">' + esc(h.title) + '</div>' +
          '<a class="cf-pc-link" href="' + esc(h.url) + '">View product ' + VIEW_ICON + '</a>' +
        '</div>' +
        '<div class="cf-pc-price"><div class="cf-pc-amt">' + esc(h.price) + '</div><div class="cf-pc-lbl">This product</div></div>' +
      '</article>';

    if (!S.entries.length) {
      wrap.innerHTML = card0 +
        '<div class="cf-empty"><b>No compatible parts listed yet</b>' +
        '<span>This product has no compatible collections set.</span>' +
        '<div class="cf-es-chips"><button class="cf-es-chip" data-change>Choose another product</button></div></div>';
      wireChange(wrap);
      return;
    }

    var chipKeys = ['All'].concat((h.cc || []).filter(function (ch) {
      return S.entries.some(function (e) { return e.chips.indexOf(ch) !== -1; });
    }));
    var chipsHtml = chipKeys.map(function (k) {
      var n = k === 'All' ? S.entries.length : S.entries.filter(function (e) { return e.chips.indexOf(k) !== -1; }).length;
      var label = k === 'All' ? 'All' : chipTitle(k);
      return '<button class="cf-cat" data-cat="' + esc(k) + '" aria-pressed="' + (k === S.activeChip) + '">' + esc(label) + '<span class="cf-n">' + n + '</span></button>';
    }).join('');

    wrap.innerHTML =
      card0 +
      '<div class="cf-chead">' +
        '<h2>' + esc(S.cfg.compatHeading) + '</h2>' +
        '<span class="cf-count" data-count></span>' +
        '<span class="cf-chead-sp"></span>' +
        '<button class="cf-reset" data-change>Start over</button>' +
        '<div class="cf-filter-field">' +
          '<svg class="cf-ic" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"><circle cx="11" cy="11" r="7"/><path d="m20 20-3.2-3.2"/></svg>' +
          '<input type="search" data-filter placeholder="' + esc(S.cfg.filterPh) + '" aria-label="' + esc(S.cfg.filterPh) + '" autocomplete="off">' +
        '</div>' +
      '</div>' +
      '<div class="cf-cats">' + chipsHtml + '</div>' +
      '<div class="cf-grid" data-grid></div>' +
      '<div class="cf-nomatch" data-nomatch hidden><b>Nothing matches that filter.</b><br>Try a broader term or clear the search.</div>';

    wireChange(wrap);
    wireCats(wrap);
    wireFilter(wrap);
    paintGrid();
  }

  function currentList() {
    var list = S.entries;
    if (S.activeChip !== 'All') list = list.filter(function (e) { return e.chips.indexOf(S.activeChip) !== -1; });
    var q = (S.view.querySelector('[data-filter]') || {}).value || '';
    if (q.trim()) {
      var parts = filterResults(list.map(function (e) { return e.part; }), q);
      var keep = {}; parts.forEach(function (p) { keep[p.handle] = 1; });
      list = list.filter(function (e) { return keep[e.part.handle]; });
    }
    return list;
  }

  function paintGrid() {
    var grid = S.view.querySelector('[data-grid]');
    var nomatch = S.view.querySelector('[data-nomatch]');
    var count = S.view.querySelector('[data-count]');
    var list = currentList();
    var base = S.activeChip === 'All' ? S.entries.length
      : S.entries.filter(function (e) { return e.chips.indexOf(S.activeChip) !== -1; }).length;
    if (count) count.innerHTML = '<b>' + list.length + '</b> ' + (list.length === 1 ? 'item' : 'items') + (list.length !== base ? ' of ' + base : '');
    if (!list.length) { grid.innerHTML = ''; if (nomatch) nomatch.hidden = false; return; }
    if (nomatch) nomatch.hidden = true;
    grid.innerHTML = list.map(card).join('');
  }

  function wireChange(wrap) {
    [].slice.call(wrap.querySelectorAll('[data-change]')).forEach(function (a) {
      a.addEventListener('click', function (e) { e.preventDefault(); location.hash = ''; });
    });
  }
  function wireCats(wrap) {
    var cats = wrap.querySelector('.cf-cats');
    if (!cats) return;
    cats.addEventListener('click', function (e) {
      var b = e.target.closest('[data-cat]'); if (!b) return;
      S.activeChip = b.getAttribute('data-cat');
      [].slice.call(cats.children).forEach(function (c) { c.setAttribute('aria-pressed', c === b); });
      paintGrid();
    });
  }
  function wireFilter(wrap) {
    var input = wrap.querySelector('[data-filter]');
    if (input) input.addEventListener('input', paintGrid);
  }

  /* ===================== add to cart ===================== */
  function addToCart(variantId, btn) {
    if (!window.theme || !theme.routes || !theme.utils) { window.location.href = '/cart'; return; }
    var original = btn.textContent;
    btn.setAttribute('aria-busy', 'true'); btn.disabled = true;
    var sectionsToBundle = [];
    document.documentElement.dispatchEvent(new CustomEvent('cart:bundled-sections', { bubbles: true, detail: { sections: sectionsToBundle } }));
    var body = JSON.stringify({ items: [{ id: variantId, quantity: 1 }], sections: sectionsToBundle, sections_url: window.location.pathname });
    fetch(theme.routes.cart_add_url, Object.assign({}, theme.utils.fetchConfig('javascript'), { body: body }))
      .then(function (r) { return r.json(); })
      .then(function (parsed) {
        if (parsed.status) { btn.textContent = parsed.message || 'Unavailable'; return; }
        return fetch(theme.routes.cart_url, Object.assign({}, theme.utils.fetchConfig('json', 'GET')))
          .then(function (r) { return r.json(); })
          .then(function (cartJson) {
            cartJson.sections = parsed.sections;
            theme.pubsub.publish(theme.pubsub.PUB_SUB_EVENTS.cartUpdate, { source: 'compatibility-finder', cart: cartJson });
            var drawer = document.querySelector('cart-drawer');
            if (drawer && drawer.show) drawer.show();
            btn.textContent = 'Added ✓';
          });
      })
      .catch(function () { btn.textContent = 'Try again'; })
      .finally(function () {
        btn.removeAttribute('aria-busy'); btn.disabled = false;
        setTimeout(function () { if (btn.isConnected) btn.textContent = original; }, 1800);
      });
  }

  /* delegated add-to-cart (the view container persists across renders) */
  if (typeof document !== 'undefined') {
    document.addEventListener('click', function (e) {
      var add = e.target.closest('[data-add]');
      if (add && add.closest('[data-compat-app]')) { e.preventDefault(); addToCart(add.getAttribute('data-add'), add); }
    });
  }

  return {
    norm: norm, tokenize: tokenize, searchProducts: searchProducts, filterResults: filterResults,
    _boot: boot
  };
});
